import Toast from "@/common/components/ui/toast";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import Dashboard from "@/common/components/layout/Dashboard";
import ReferrealReportsPage from "./components/TableReferrealReports/ReferrealReports.page";


function ReferrealReports() {
    return (
        <ToastProvider>
            <Dashboard>
                <ReferrealReportsPage />
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}

export default ReferrealReports